import React from "react";
import {
  RefreshCw,
  ExternalLink,
  Eye,
  Code,
  Database,
  TvMinimalPlay,
  Cog,
  FolderOpen,
} from "lucide-react";
import ViewModeSelector from "./ViewModeSelector";
import PublishMenu from "../../../project/PublishMenu";

const BrowserControls = ({
  sandboxHost,
  onRefresh,
  onOpenInNewWindow,
  viewMode,
  onViewModeChange,
  isDesktopView,
  onViewChange,
  viewDropdownOpen,
  setViewDropdownOpen,
  workspace,
  onOpenProjectSettings,
}) => {
  const handleViewModeClick = (mode) => {
    onViewModeChange(mode);
  };

  // Desktop layout
  return (
    <div className="flex items-center bg-white dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-700 px-3 py-2">
      {/* View Mode Toggle */}
      <div className="flex bg-neutral-100 dark:bg-neutral-700 rounded-lg p-0.5 mr-3">
        {/* Show preview button only if project_mode is 'vibe' */}
        {workspace?.project_mode === "vibe" && (
          <button
            className={`px-3 py-1 text-sm font-medium rounded transition-colors ${
              viewMode === "preview"
                ? "bg-white dark:bg-neutral-800 text-ui-text-primary shadow-sm"
                : "text-ui-text-secondary hover:text-ui-text-primary"
            }`}
            onClick={() => handleViewModeClick("preview")}
            title="Preview"
          >
            <Eye size={14} className="inline mr-1" />
          </button>
        )}

        {/* Always show monitor button */}
        <button
          className={`px-3 py-1 text-sm font-medium rounded transition-colors ${
            viewMode === "monitor"
              ? "bg-white dark:bg-neutral-800 text-ui-text-primary shadow-sm"
              : "text-ui-text-secondary hover:text-ui-text-primary"
          }`}
          onClick={() => handleViewModeClick("monitor")}
          title="Monitor"
        >
          <TvMinimalPlay size={14} className="inline mr-1" />
        </button>

        <button
          className={`px-3 py-1 text-sm font-medium rounded transition-colors ${
            viewMode === "code"
              ? "bg-white dark:bg-neutral-800 text-ui-text-primary shadow-sm"
              : "text-ui-text-secondary hover:text-ui-text-primary"
          }`}
          onClick={() => handleViewModeClick("code")}
          title="Code"
        >
          <Code size={14} className="inline mr-1" />
        </button>
        <button
          className={`px-3 py-1 text-sm font-medium rounded transition-colors ${
            viewMode === "database"
              ? "bg-white dark:bg-neutral-800 text-ui-text-primary shadow-sm"
              : "text-ui-text-secondary hover:text-ui-text-primary"
          }`}
          onClick={() => handleViewModeClick("database")}
          title="Database"
        >
          <Database size={14} className="inline mr-1" />
        </button>

        {/* Files (Project) view */}
        <button
          className={`px-3 py-1 text-sm font-medium rounded transition-colors ${
            viewMode === "project_files"
              ? "bg-white dark:bg-neutral-800 text-ui-text-primary shadow-sm"
              : "text-ui-text-secondary hover:text-ui-text-primary"
          }`}
          onClick={() => handleViewModeClick("project_files")}
          title="Project Files"
        >
          <FolderOpen size={14} className="inline mr-1" />
        </button>

        {/* Project Settings (Cog) */}
        <button
          className="px-3 py-1 text-sm font-medium rounded transition-colors text-ui-text-secondary hover:text-ui-text-primary"
          onClick={onOpenProjectSettings}
          title="Project Settings"
          aria-label="Project Settings"
        >
          <Cog size={14} className="inline mr-1" />
        </button>
      </div>

      {/* Always show refresh button */}
      <button
        className="p-1.5 text-ui-text-secondary hover:text-ui-text-primary hover:bg-neutral-100 dark:hover:bg-neutral-700 rounded transition-colors"
        onClick={onRefresh}
        title="Refresh"
      >
        <RefreshCw size={16} />
      </button>

      {/* Show preview-specific controls only in preview mode */}
      {viewMode === "preview" && (
        <>
          <div className="flex-1 mx-3">
            <input
              type="text"
              value={sandboxHost ? `https://${sandboxHost}` : ''}
              placeholder="Sandbox environment not ready"
              className="w-full px-3 py-1 text-sm bg-neutral-50 dark:bg-neutral-900 rounded border border-neutral-200 dark:border-neutral-600 text-ui-text-primary cursor-default"
              readOnly
            />
          </div>

          {/* View Mode Dropdown */}
          <ViewModeSelector
            isDesktopView={isDesktopView}
            onViewChange={onViewChange}
            isOpen={viewDropdownOpen}
            onToggle={setViewDropdownOpen}
          />

          <button
            className={`p-1.5 text-ui-text-secondary hover:text-ui-text-primary hover:bg-neutral-100 dark:hover:bg-neutral-700 rounded transition-colors ${!sandboxHost ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={onOpenInNewWindow}
            title="Open in New Window"
            disabled={!sandboxHost}
            aria-disabled={!sandboxHost}
          >
            <ExternalLink size={16} />
          </button>
        </>
      )}

      {/* Add some spacing when not in preview mode */}
      {(viewMode === "code" ||
        viewMode === "database" ||
        viewMode === "monitor" ||
        viewMode === "project_files") && <div className="flex-1" />}
    </div>
  );
};

export default BrowserControls;
